import React, { useEffect, useRef, useState } from "react";
import { ReactComponent as Plus } from "../../assets/images/icons/Plues.svg";
import { ReactComponent as AddTemplateCircle } from "../../assets/images/icons/AddTemplateCircle.svg";
import { ReactComponent as AddGray } from "../../assets/images/icons/addGrayIcon.svg";
import { ReactComponent as Drag } from "../../assets/images/icons/DragIcon.svg";
import { ReactComponent as Undo } from "../../assets/images/icons/Undo.svg";
import { ReactComponent as CrossIcon } from "../../assets/images/crossIconAdvancedFilter.svg";
import { ReactComponent as NewDelete } from "../../assets/images/NewDelete.svg";
import { ReactComponent as ThreeDotVertical } from "../../assets/images/threeDotVertical.svg";
import { ReactComponent as EditIconAdvancedFilter } from "../../assets/images/disableImg.svg";
import { ReactComponent as EmmptySection } from "../../assets/images/icons/Empysection.svg";
import { ReactComponent as ExtenedView } from "../../assets/images/icons/ExtendeView.svg";
import { ReactComponent as FullView } from "../../assets/images/icons/FullView.svg";
import { ReactComponent as ActiveLink } from "../../assets/images/icons/ActiveLink.svg";
import { ReactComponent as ActiveActivity } from "../../assets/images/icons/ActiveActivity.svg";
import { ReactComponent as ActiveAttachment } from "../../assets/images/icons/ActiveAttachment.svg";
import { ReactComponent as UploadIcon } from "../../assets/images/uploadIcon.svg";
import { ReactComponent as Lock } from "../../assets/images/icons/Lock.svg";
import MotionSearchBox from "../UniversalComponents/MotionSearchBox";
import { Dialog, FormControlLabel, Switch } from "@mui/material";
import InputComponent from "../UniversalComponents/InputComponent";
import Button from "./../UniversalComponents/DefaultButton";
import AddFieldDrawer from "../GlobalFeature/Table/AddFieldDrawer";
import DatePickerComponent from "../UniversalComponents/DatePickerComponent";
import BasicSelect from "../Task/BasicSelect";
import styled from "@emotion/styled";
import { date } from "yup";
import FloatingElement from "../UniversalComponents/FloatingElement";
import ConfirmationDialog from "../UniversalComponents/ConfirmationDialogMulti";
import MultiSelect from "../customer/MultiSelect";
import ToggleMultiSwitch from "../UniversalComponents/ToggleMultiSwitch";
import AvatarName from "../UniversalComponents/AvatarName";
import useClickOutside from "../../hooks/Screen/useClickOutside";
import { usePostApiMutation } from "../../utils/customer/customerTaskTable";
import { NODE_URL } from "../../utils/constants";
import { useDispatch } from "react-redux";
import { hideLoader, showLoader } from "../../utils/loaderSlice";
import { pushAlert } from "../../utils/alertSlice";
import {
  useFetchAllSectionsQuery,
  useLazyFetchFieldValuesQuery,
  useLazyFetchSectionFieldsQuery,
  useDeleteSectionMutation,
  useDeleteFieldMutation,
} from "../../utils/customer/customerSelect";
import { getInitials } from "../../utils/utilityFunctions/stringUtility";

const AddSection = ({
  sectionDetails,
  setSectionDetails,
  setSectionID,
  sectionlist,
  setSectionlist,
  RefetchAllSections,
}) => {
  const [companySearchTerm, setCompanySearchTerm] = useState("");
  const [viewName, setViewName] = useState("");
  const [openSectionField, setOpenSectionField] = useState(false);
  const [addField, setAddField] = useState(false);
  const dropdownRef = useRef(null);
  const [isConfirmSectionDelete, setIsConfirmSectionDelete] = useState(false);
  const [isConfirmFieldDelete, setIsConfirmFieldDelete] = useState(false);
  const [sectionName, setSectionName] = useState(null);
  const [sectionFields, setSectionFields] = useState(null);
  const [toggleValue, setToggleValue] = useState("full");
  const [CopySection, setCopySection] = useState(null);
  const [visibleSectionDetail, setVisibleSectionDetail] = useState(false);
  const [dropdownOptionsMap, setDropdownOptionsMap] = useState({});
  const [fieldDropDownValue, setFieldDropDownValue] = useState({});
  const [fetchApiCall, setFetchApiCall] = useState(false);
  const [deleteField, setDeleteField] = useState(null);

  const [editFieldData, setEditFieldData] = useState(null);

  const dispatch = useDispatch();

  // 1. Create/Update Section
  const [
    AddUpdateSection,
    {
      data: SectionData,
      isLoading: isSectionDataLoading,
      isError: isSectionDataError,
      isSuccess: isSectionDataSuccess,
      error: sectionError,
    },
  ] = usePostApiMutation();

  // 2. Create/Update Field in Section
  const [
    AddUpdateField,
    {
      data: FieldData,
      isLoading: isFieldDataLoading,
      isError: isFieldDataError,
      isSuccess: isFieldDataSuccess,
      error: fieldError,
    },
  ] = usePostApiMutation();

  // 3. Get All Sections shifted to one step up

  // 4. Get Fields for Section
  const [
    FetchSectionFields,
    {
      data: GetSectionFields,
      isError: isSectionFieldsError,
      isSuccess: isSectionFieldsSuccess,
      error: SectionFieldsError,
    },
  ] = useLazyFetchSectionFieldsQuery();

  // 5. Get Field Values
  const [
    FetchFieldValues,
    { data: GetFieldValues, isError: isFieldValuesError, isSuccess: isFieldValuesSuccess, error: FieldValuesError },
  ] = useLazyFetchFieldValuesQuery();

  // 6. Delete Section
  const [
    DeleteSection,
    {
      data: DeleteSectionData,
      isLoading: isDeleteSectionLoading,
      isError: isDeleteSectiondError,
      isSuccess: isDeleteSectiondSuccess,
      error: DeleteSectiondError,
    },
  ] = useDeleteSectionMutation();

  // 7. Delete Section
  const [
    DeleteField,
    {
      data: DeleteFieldData,
      isLoading: isDeleteFieldLoading,
      isError: isDeleteFieldError,
      isSuccess: isDeleteFieldSuccess,
      error: DeleteFieldError,
    },
  ] = useDeleteFieldMutation();

  // 🔁 HANDLE DELETE SECTION
  useEffect(() => {
    if (isDeleteSectionLoading) {
      dispatch(showLoader());
    } else {
      dispatch(hideLoader());
    }

    if (isDeleteSectiondSuccess && DeleteSectionData?.status) {
      dispatch(
        pushAlert({
          message: DeleteSectionData.message || "Section deleted successfully",
          type: "success",
          visible: true,
        })
      );
      RefetchAllSections(); // refresh list after delete
    } else if (isDeleteSectiondError) {
      dispatch(
        pushAlert({
          message: DeleteSectiondError?.data?.message || "Error deleting section",
          type: "danger",
          visible: true,
        })
      );
    }
    setIsConfirmSectionDelete(false); // close confirmation dialog
  }, [isDeleteSectionLoading, isDeleteSectiondSuccess, isDeleteSectiondError, DeleteSectionData, DeleteSectiondError]);

  // 🔁 HANDLE ADD/UPDATE SECTION
  useEffect(() => {
    if (isSectionDataLoading) {
      dispatch(showLoader());
    } else {
      dispatch(hideLoader());
    }

    if (isSectionDataSuccess && SectionData?.success) {
      dispatch(pushAlert({ message: SectionData.message, type: "success", visible: true }));
      RefetchAllSections();
      FetchSectionFields({ sectionId: sectionDetails?.id });
      setVisibleSectionDetail(true);
    } else if (isSectionDataError) {
      dispatch(
        pushAlert({ message: sectionError?.data?.message || "Error adding section", type: "danger", visible: true })
      );
    }
  }, [isSectionDataLoading, isSectionDataSuccess, isSectionDataError]);

  // 🔁 HANDLE FETCH SECTION FIELDS
  useEffect(() => {
    if (isSectionFieldsSuccess) {
      setSectionFields(GetSectionFields?.data);
      dispatch(pushAlert({ message: GetSectionFields.message || "Fields fetched", type: "success", visible: true }));
    }

    if (isSectionFieldsError) {
      dispatch(
        pushAlert({
          message: SectionFieldsError?.data?.message || "Error fetching fields",
          type: "danger",
          visible: true,
        })
      );
    }
  }, [GetSectionFields, isSectionFieldsSuccess, isSectionFieldsError]);

  // 🔁 HANDLE ADD/UPDATE FIELD
  useEffect(() => {
    if (isFieldDataLoading) {
      dispatch(showLoader());
    } else {
      dispatch(hideLoader());
    }

    if (isFieldDataSuccess && FieldData?.status) {
      dispatch(pushAlert({ message: FieldData.message, type: "success", visible: true }));
      FetchSectionFields({ sectionId: sectionDetails?.id });
    } else if (isFieldDataError) {
      dispatch(
        pushAlert({ message: fieldError?.data?.message || "Error adding field", type: "danger", visible: true })
      );
    }
  }, [isFieldDataLoading, isFieldDataSuccess, isFieldDataError]);

  // 🔁 HANDLE DELETE FIELD
  useEffect(() => {
    if (isDeleteFieldLoading) {
      dispatch(showLoader());
    } else {
      dispatch(hideLoader());
    }

    if (isDeleteFieldSuccess && DeleteFieldData?.status) {
      dispatch(
        pushAlert({
          message: DeleteFieldData.message || "Field deleted successfully",
          type: "success",
          visible: true,
        })
      );

      FetchSectionFields({ sectionId: sectionDetails?.id });
    } else if (isDeleteFieldError) {
      dispatch(
        pushAlert({
          message: DeleteFieldError?.data?.message || "Error deleting field",
          type: "danger",
          visible: true,
        })
      );
    }
    setIsConfirmFieldDelete(false); // close confirmation dialog
  }, [isDeleteFieldLoading, isDeleteFieldSuccess, isDeleteFieldError, DeleteFieldData, DeleteFieldError]);

  const CloseSectionNameField = useClickOutside(() => {
    setOpenSectionField((prev) => !prev);
  });

  const MatchIcon = {
    Activity: (
      <div className="p-[8px] bg-[#F0F0F0] rounded-lg">
        <ActiveActivity />
      </div>
    ),
    LinkToTask: (
      <div className="p-[8px] bg-[#F0F0F0] rounded-lg">
        <ActiveLink />
      </div>
    ),
    Attachment: (
      <div className="p-[8px] bg-[#F0F0F0] rounded-lg">
        <ActiveAttachment />
      </div>
    ),
  };

  // useEffect(() => {
  //   if (CopySection) {
  //     setSectionDetails((prev) => [...prev, CopySection]);
  //     setSectionFields(() => [CopySection]);
  //   }
  // }, [CopySection]);

  const handleFieldChange = (field, newValue) => {
    if (field && field.id) {
      setFieldDropDownValue((prev) => ({
        ...prev,
        [field.id]: newValue,
      }));
    }
  };

  const IOSSwitch = styled((props) => <Switch focusVisibleClassName=".Mui-focusVisible" disableRipple {...props} />)(
    ({ theme }) => ({
      width: 42,
      height: 22,
      padding: 0,
      "& .MuiSwitch-switchBase": {
        padding: 0,
        margin: 2,
        transitionDuration: "300ms",
        "&.Mui-checked": {
          transform: "translateX(16px)",
          color: "#fff",
          "& + .MuiSwitch-track": {
            backgroundColor: "#65C466",
            opacity: 1,
            border: 0,
            ...theme.applyStyles("dark", {
              backgroundColor: "#2ECA45",
            }),
          },
          "&.Mui-disabled + .MuiSwitch-track": {
            opacity: 0.5,
          },
        },
        "&.Mui-focusVisible .MuiSwitch-thumb": {
          color: "#33cf4d",
          border: "6px solid #fff",
        },
        "&.Mui-disabled .MuiSwitch-thumb": {
          color: theme.palette.grey[100],
          ...theme.applyStyles("dark", {
            color: theme.palette.grey[600],
          }),
        },
        "&.Mui-disabled + .MuiSwitch-track": {
          opacity: 0.7,
          ...theme.applyStyles("dark", {
            opacity: 0.3,
          }),
        },
      },
      "& .MuiSwitch-thumb": {
        boxSizing: "border-box",
        width: 22,
        height: 22,
      },
      "& .MuiSwitch-track": {
        borderRadius: 26 / 2,
        backgroundColor: "#E9E9EA",
        opacity: 1,
        transition: theme.transitions.create(["background-color"], {
          duration: 500,
        }),
        ...theme.applyStyles("dark", {
          backgroundColor: "#39393D",
        }),
      },
    })
  );

  const fetchAndSetFieldOptions = async (field) => {
    const response = await FetchFieldValues({
      FieldName: field?.value,
    }).unwrap();

    if (response?.data) {
      setDropdownOptionsMap((prev) => ({
        ...prev,
        [field.id]: response.data.map((option) => ({
          label: option.label,
          value: option.id,
        })),
      }));

      setEditFieldData((prev) => ({
        ...prev,
        field_options: response?.data.map((field) => ({
          value: field?.value?.value,
          color_code: field?.value?.color,
        })),
      }));
    }
  };

  const renderFieldByType = (field, handleFieldChange) => {
    switch (field?.type) {
      case "text":
      case "string":
        return (
          <div className="w-full">
            <InputComponent
              type="text"
              placeholder={field.label}
              value={fieldDropDownValue[field.key] || ""}
              onChange={(e) => handleFieldChange(field, e.target.value)}
              isDisabled
            />
          </div>
        );

      case "int":
      case "integer":
      case "number":
      case "float":
        return (
          <div className="w-full">
            <InputComponent
              type="number"
              value={fieldDropDownValue[field.key] || ""}
              placeholder={field.label}
              onChange={(e) => handleFieldChange(field, e.target.value)}
              isDisabled
            />
          </div>
        );

      case "boolean":
      case "checkbox":
        return (
          <FormControlLabel
            control={
              <IOSSwitch
                checked={fieldDropDownValue[field.key] || false}
                onChange={(e) => handleFieldChange(field, e.target.checked)}
                disabled
              />
            }
          />
        );

      case "date":
        return (
          <DatePickerComponent
            value={fieldDropDownValue[field.key] || ""}
            onChange={(e) => handleFieldChange(field, e.target.value)}
            className="w-full rounded-md"
            placeholder="Select date"
            size="small"
            innerClassName="h-[35px]"
            isDisabled
          />
        );

      case "Dropdown":
      case "dropdown":
      case "multiselect":
      case "select":
        return (
          <div className="w-full border-b-[1px] rounded-lg">
            <BasicSelect
              isMulti
              size="large"
              onChange={(selected) => handleFieldChange(field, selected)}
              className="w-full px-3 py-2 border rounded-md border-b-[1px]"
              apiCall={() => fetchAndSetFieldOptions(field)}
              options={dropdownOptionsMap[field.id] || []}
              selectedOptions={
                fieldDropDownValue[field.id]?.target
                  ? [
                      {
                        label: fieldDropDownValue[field.id].target.label,
                        value: fieldDropDownValue[field.id].target.value,
                      },
                    ]
                  : []
              }
              disabled
            />
          </div>
        );

      case "Attachment":
      case "attachment":
      case "file":
        return (
          <div className="flex flex-col items-center justify-center gap-[9px] p-2.5 pl-2.5 self-stretch h-[127px]">
            <div className="flex flex-col gap-y-2 justify-center items-center">
              <span className="font-poppins text-sm font-normal capitalize text-[#66666699]">
                Drop files here or click to select from the device
              </span>
              <button className="flex items-center justify-center px-7 py-[10px] bg-[#F4F4F4] gap-x-3 border-2 rounded-md">
                <span className="text-sm font-semibold uppercase text-[#666666]">Upload from this device</span>
                <UploadIcon fill="#666666" className="w-5 h-5" />
              </button>
            </div>
          </div>
        );

      default:
        return (
          <div className="w-full">
            <InputComponent
              type="text"
              placeholder={field.label}
              value={fieldDropDownValue[field.key] || ""}
              onChange={(e) => handleFieldChange(field, e.target.value)}
              isDisabled
            />
          </div>
        );
    }
  };

  //for field add into a section
  const handleAddField = async (FieldValue) => {
    setAddField(!addField);
    const updatedColorOptions = FieldValue?.field_options?.map(({ color_code, ...rest }) => ({
      ...rest,
      color: color_code,
    }));
    const payload = {
      field_label: FieldValue && FieldValue?.field_label,
      field_type: FieldValue && FieldValue?.field_type,
      description: FieldValue && FieldValue?.field_description,
      section_id: sectionDetails?.id,
      dropdown_options: updatedColorOptions,
      meta: FieldValue?.meta,
    };
    AddUpdateField({ data: payload, url: `${NODE_URL}template/section/field/create` });
  };

  //add and update the section (name)
  const handleAddAndUpdateSection = () => {
    if (openSectionField) {
      setOpenSectionField(!openSectionField);
    }
    const payload = {
      id: sectionDetails?.id,
      section_name: sectionDetails?.section_name,
    };

    AddUpdateSection({ data: payload, url: `${NODE_URL}template/section` });
  };

  const handleFetchFields = () => {
    FetchSectionFields({ sectionId: sectionDetails?.id });
    setVisibleSectionDetail(true);
  };

  const handleDeleteSection = () => {
    DeleteSection({ SectionId: sectionDetails?.id });
  };
  const handleDeleteField = () => {
    if (deleteField) {
      DeleteField({ field_value: deleteField?.value });
    }
  };

  useEffect(() => {
    if (sectionDetails?.id && fetchApiCall) {
      handleFetchFields();
      setFetchApiCall(false);
    } else {
      // setSectionFields(null);
    }
  }, [sectionDetails, fetchApiCall]);

  const EditExtraField = (headeritem) => {
    // const filteredItem = orderedThead?.find((item) => item.value === headeritem);
    setEditFieldData({
      field_label: headeritem?.label,
      field_type: headeritem?.type,
      field_value: headeritem?.value,
      field_id: headeritem?.id,
      field_option: [],
      decimalPlaces: headeritem?.meta?.numberFormat?.decimalPlaces,
      negativeFormat: headeritem?.meta?.numberFormat?.negativeFormat,
      selectedOption: headeritem?.meta?.numberFormat?.selectedOption,
      separators: headeritem?.meta?.numberFormat?.separators,
      symbol: headeritem?.meta?.numberFormat?.symbol,
      textSelectedOption: headeritem?.meta?.textFormat?.textSelectedOption,
    });

    if (headeritem?.type === "dropdown" || headeritem?.type === "multiselect") {
      fetchAndSetFieldOptions(headeritem);
    }
  };

  //drag function
  const handleSectionName = (section) => {
    if (section) {
      setSectionDetails(section);
    }
    setSectionFields(null);
    setVisibleSectionDetail(false);
  };

  const escapeRegExp = (string) => {
    return string.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
  };

  const highlightText = (text, query) => {
    if (!text || !query) return text || "";

    const textStr = String(text);

    try {
      const regex = new RegExp(`(${escapeRegExp(query)})`, "gi");
      const parts = textStr.split(regex);

      return parts.map((part, index) =>
        regex.test(part) ? (
          <span key={index} className="bg-yellow-200">
            {part}
          </span>
        ) : (
          part // keep the rest exactly as it was
        )
      );
    } catch (error) {
      return textStr;
    }
  };

  function toUnderscoreFormat(input) {
    return input.trim().replace(/\s+/g, "_");
  }
  const getDDMonthYYYYHM = (dateString) => {
    if (!dateString) {
      return;
    }

    const date = new Date(dateString);
    const day = date.getDate();
    const month = date.toLocaleString("default", { month: "long" });
    const year = date.getFullYear();

    const hours = date.getHours().toString().padStart(2, "0");
    const minutes = date.getMinutes().toString().padStart(2, "0");

    return `${day} ${month} ${year}, ${hours}:${minutes}`;
  };

  console.log("sectionDetails", sectionDetails);

  return (
    <>
      <div className="py-2 px-3 flex items-centre justify-start overflow-y-auto">
        <div className="w-full flex items-start justify-start gap-x-4">
          {/* section list */}
          <div className="max-w-[22vw] w-[22vw] h-[calc(100vh-121px)] border border-[#BECBD3] rounded-md flex flex-col">
            <h1 className="text-[#1D4469] font-[Poppins] text-lg font-medium lowercase leading-normal border-b py-3 px-4 border-[#BECBD3]">
              Section List
            </h1>

            <div className="px-3 mt-3 gap-3 flex flex-col overflow-y-auto justify-start h-full">
              <div>
                <MotionSearchBox
                  expanded={true}
                  isSearchActive={true}
                  searchText={companySearchTerm}
                  setSearchText={setCompanySearchTerm}
                  placeholder="Search..."
                />
              </div>

              <div className="flex flex-col w-full gap-y-3 py-1 min-h-0 grow overflow-y-auto scrollbar-hidden">
                {sectionlist
                  ?.filter(
                    (list) =>
                      list?.section_name && list?.section_name.toLowerCase().includes(companySearchTerm.toLowerCase())
                  )
                  ?.map((section, i) => (
                    <div
                      key={section?.id}
                      draggable
                      onDragStart={(e) => {
                        if (section?.id === sectionDetails?.id && visibleSectionDetail) {
                          e.preventDefault();
                          return;
                        }
                        handleSectionName(section);
                      }}
                      className={`flex items-center group justify-start px-3 py-2 border border-[#BECBD3] rounded-md w-full gap-x-3 hover:bg-535252 hover:text-[#e8e9e9] ${section?.section_name === sectionDetails?.section_name && visibleSectionDetail ? "text-white bg-[#1d4469]" : "text-[#666] cursor-pointer"} `}
                    >
                      <Drag className="cursor-pointer" />
                      <input
                        type="checkbox"
                        onChange={(e) => {
                          if (section?.id === sectionDetails?.id && visibleSectionDetail) {
                            e.preventDefault();
                            return;
                          }
                          handleSectionName(section);
                          setFetchApiCall(true);
                        }}
                        checked={section?.id === sectionDetails?.id && visibleSectionDetail}
                        className="w-4 h-4 accent-[#e34d23] cursor-pointer border-[#BECBD3] rounded-sm"
                      />
                      <span
                        className={`font-[Poppins] text-base font-medium leading-normal flex items-center justify-center`}
                      >
                        {highlightText(section?.section_name, companySearchTerm)}
                      </span>
                      {section?.is_locked === 1 && <Lock fill="#C9CDD7" />}
                    </div>
                  ))}
              </div>
              <div className="flex items-center justify-end">
                <div className="flex items-center justify-center w-full gap-x-2 pb-2">
                  {/* <button
              className="text-[#666] text-base font-500 py-2 px-3 bg-[#F4F4F4] rounded-lg border border-[#D2DAE1]"
              onClick={() => HandleCopyDrgItem()}
            >
              Copy Section
            </button> */}
                  <div
                    className="flex items-center w-full justify-center px-4 py-2 bg-[#1D4469] gap-2 rounded-lg"
                    onClick={(e) => {
                      e.stopPropagation();
                      setOpenSectionField(!openSectionField);
                      setSectionFields(null);
                      setSectionDetails({});
                      setSectionName(null);
                    }}
                  >
                    <AddTemplateCircle fill="#ffffff" />
                    <button className="text-white text-base">Add Section</button>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* Section with field*/}
          <div className="max-w-[48vw] w-[48vw]  h-[calc(100vh-121px)] border border-[#BECBD3] rounded-md flex flex-col justify-between">
            <div className="py-2 px-4 flex items-center  justify-end border-b border-[#BECBD3] gap-x-4">
              {openSectionField ? (
                <div className="w-full h-9" ref={CloseSectionNameField}>
                  <InputComponent
                    placeholder="Enter section name"
                    value={sectionDetails?.section_name}
                    name="name"
                    onChange={(e) =>
                      setSectionDetails((prev) => ({
                        ...prev,
                        section_name: e.target.value,
                      }))
                    }
                    onKeyDown={(e) => {
                      if (e.key === "Enter") handleAddAndUpdateSection();
                    }}
                    maxLength={35}
                    autoFocus
                    className="text-[#1D4469] font-[Poppins] text-lg font-700 leading-normal"
                  />
                </div>
              ) : (
                <h4
                  className="w-full h-9 flex items-center justify-start text-[#1D4469] font-[Poppins] text-lg font-medium leading-normal cursor-pointer"
                  onClick={(e) => {
                    setSectionID(sectionDetails?.id);
                    setOpenSectionField((prev) => !prev);
                  }}
                >
                  {visibleSectionDetail && sectionDetails?.section_name}
                </h4>
              )}

              <div
                className={`${sectionDetails?.is_locked === 1 ? "hidden" : "flex items-centre justify-center"}  gap-x-3`}
              >
                <div>
                  <ToggleMultiSwitch
                    className="h-8"
                    onToggle={(value) => setToggleValue(value)}
                    options={[
                      {
                        label: (
                          <ExtenedView fill={toggleValue === "extened" ? "#1D4469" : "#8E8E8E"} className="p-[2px]" />
                        ),
                        value: "extened",
                      },
                      {
                        label: <FullView fill={toggleValue === "full" ? "#1D4469" : "#8E8E8E"} className="p-[2px]" />,
                        value: "full",
                      },
                    ]}
                    defaultValue="full"
                  />
                </div>
                <div className="flex items-center justify-center gap-x-3">
                  {sectionFields?.map((item) => {
                    return MatchIcon[item?.key];
                  })}
                  <div className="h-7 w-[2px] py-2 bg-[#F0F0F0]"></div>
                </div>

                <div className="flex items-center justify-center gap-x-2">
                  <NewDelete className="cursor-pointer h-4" onClick={() => setIsConfirmSectionDelete(true)} />
                  <AddGray className="cursor-pointer" onClick={() => setAddField(true)} />
                </div>
              </div>
            </div>

            <div
              onDragOver={(e) => e.preventDefault()}
              onDrop={(e) => {
                e.preventDefault();
                setFetchApiCall(true);
              }}
              className={`min-h-0 grow overflow-y-auto  scrollbar-hidden`}
            >
              {sectionFields?.length ? (
                <form className="grid grid-cols-2 gap-4 w-full gap-y-2 p-3">
                  {sectionFields?.map((field, index) => (
                    <div
                      key={field?.field_id}
                      // draggable
                      // onDragOver={(e) => e.preventDefault()}
                      className={`${toggleValue === "full" ? "col-span-2" : "col-span-1"}`}
                    >
                      <div className="flex flex-col items-center justify-start w-full mb-2 gap-y-2">
                        <div className="w-full flex items-center justify-center gap-3 border border-gray-300 border-dashed p-2 rounded-md">
                          <Drag className="cursor-pointer" />

                          <div className="w-full flex flex-col items-center justify-between">
                            <div className="w-full flex items-center justify-between mb-2">
                              <label className="w-full text-[#434852] font-poppins text-sm font-normal capitalize">
                                {field?.label}
                              </label>

                              <div
                                className={`${sectionDetails?.is_locked === 1 ? "hidden" : "flex items-end justify-center gap-x-3"} mr-1`}
                              >
                                <NewDelete
                                  className="pb-[1px] cursor-pointer h-4"
                                  onClick={() => {
                                    setIsConfirmFieldDelete((prev) => !prev);
                                    if (field) setDeleteField(field);
                                  }}
                                />
                                <EditIconAdvancedFilter
                                  className="pb-[1px] cursor-pointer h-4"
                                  onClick={() => {
                                    setAddField(true);
                                    if (field) EditExtraField(field);
                                  }}
                                />
                              </div>
                            </div>

                            {renderFieldByType(field, handleFieldChange)}
                          </div>
                        </div>
                      </div>
                    </div>
                  ))}
                </form>
              ) : (
                <div className="flex items-center justify-center h-full w-full">
                  <div className="flex flex-col justify-center items-center gap-y-2">
                    <EmmptySection />
                    <span className="text-center font-poppins text-md font-normal leading-5 capitalize text-[#66666699]">
                      Drag & Drop the section here!
                    </span>
                    {visibleSectionDetail && (
                      <div
                        className="flex items-center justify-center w-fit px-4 py-2 bg-[#F4F4F4] gap-2 rounded-md"
                        onClick={() => setAddField(true)}
                      >
                        <Plus fill="#666" />
                        <button className="text-[#666] text-base">Add Field</button>
                      </div>
                    )}
                  </div>
                </div>
              )}
            </div>

            <div className="py-3 px-4 flex items-centre justify-end border-t border-[#BECBD3] ">
              {/* <div className="flex items-center justify-center gap-1 px-2 py-1 bg-[#C9CDD7] hover:bg-[#F0F5F9] rounded-md cursor-pointer">
                <Undo />
                <span className="text-sm font-normal font-poppins text-[#434852] ">Undo</span>
              </div> */}
              <div className="flex items-center justify-center gap-2">
                <Button variant="secondary" size="small">
                  Save as Draft
                </Button>
                <Button variant="primary" size="small">
                  Deploy
                </Button>
              </div>
            </div>
          </div>
          {/* section create & updated */}
          <div className="min-w-0 grow h-36 min-h-36 bg-[#F4F4F4] rounded-md border border-[#D2DAE1] py-3 px-5 flex flex-col items-start justify-centre">
            <div className="flex items-centre justify-centre gap-x-6">
              <div className="flex items-center justify-center">
                <AvatarName
                  name={visibleSectionDetail && getInitials(sectionDetails?.created_by)}
                  size="small"
                  bgColor={"#E8ECF299"}
                  textColor={"#7C7C83"}
                  borderColor={"#ABABAC"}
                />
              </div>

              <div className="flex flex-col justify-centre items-start">
                <h4 className="text-sm font-400">
                  Created by{" "}
                  <span className="text-[#2999BC]">{visibleSectionDetail && sectionDetails?.created_by}</span>
                </h4>
                <span className="text-xs text-[#767676]">
                  {visibleSectionDetail && getDDMonthYYYYHM(sectionDetails?.created_at)}
                </span>
              </div>
            </div>

            <div className="flex items-center justify-center w-6">
              <div className="w-[2px] min-h-5 bg-[#DFE2E5]"></div>
            </div>

            <div className="flex items-centre justify-centre gap-x-6">
              <div className="flex items-center justify-center">
                <AvatarName
                  name={visibleSectionDetail && getInitials(sectionDetails?.updated_by)}
                  size="small"
                  bgColor={"#E8ECF299"}
                  textColor={"#7C7C83"}
                  borderColor={"#ABABAC"}
                />
              </div>

              <div className="flex flex-col justify-centre items-start">
                <h4 className="text-sm font-400">
                  Updated by{" "}
                  <span className="text-[#2999BC]">{visibleSectionDetail && sectionDetails?.updated_by}</span>
                </h4>
                <span className="text-xs text-[#767676]">
                  {visibleSectionDetail && getDDMonthYYYYHM(sectionDetails?.updated_at)}
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>

      {addField && (
        <AddFieldDrawer
          open={addField}
          EditFieldData={editFieldData}
          onClose={() => {
            setAddField((prev) => !prev);
            setEditFieldData(null);
          }}
          ExtraFieldAddHeader={(data) => {
            if (data) {
              handleAddField(data);
            }
          }}
        />
      )}

      {/*  section delete */}
      {isConfirmSectionDelete && (
        <ConfirmationDialog
          open={isConfirmSectionDelete}
          onConfirm={() => handleDeleteSection()} //for api
          onClose={() => setIsConfirmSectionDelete(false)}
          title="Delete Confirmation?"
          message={`Are you sure want to delete section.`}
          confirmVariant="delete"
          confirmText="Delete"
          iconVariant="Delete"
          // cancelVariant="action"
          cancelText="Cancel"
          // variant="delete"
        />
      )}

      {/* field delete */}
      {isConfirmFieldDelete && (
        <ConfirmationDialog
          open={isConfirmFieldDelete}
          onConfirm={() => handleDeleteField()} //for api
          onClose={() => setIsConfirmFieldDelete(false)}
          title="Delete Confirmation?"
          message={`Are you sure want to delete field.`}
          confirmVariant="delete"
          confirmText="Delete"
          iconVariant="Delete"
          // cancelVariant="action"
          cancelText="Cancel"
          // variant="delete"
        />
      )}
    </>
  );
};

export default AddSection;
